import type { JobView } from '@alterium/shared';
import { api, apiRequestWithMeta } from './client';

export const jobsApi = {
  list: (params: { activeOnly?: boolean; cursor?: string } = {}) =>
    apiRequestWithMeta<JobView[]>({ method: 'GET', url: '/jobs', params }),

  get: (id: string) => api.get<JobView>(`/jobs/${id}`),
  cancel: (id: string) => api.post<JobView>(`/jobs/${id}/cancel`),

  /** Служебное: проверка пути генерации до появления экрана образов (фаза 8). */
  startTestImage: (prompt: string) =>
    api.post<JobView>('/dev/generation/image', { prompt, count: 1 }),
};
